import $ from 'jquery'

const $popup = $(".pop-up-container")
const read_more_content = $('.property-details-content')
const book_now_btn = $('.book-now-floating-btn')
const read_more_button = $('.property-details-read-more')

//iframe scrollable for property reviews

//move card to right position in header
$(window).on('load resize', () => {
    const short_description = $('.short-summary-description')
    const card = $('.property-offers-container')
    const height = short_description.height()
    if (height > 60) {
        card.css('top', (-340 - ((height/2))+10))
    }
})

//dropdown for read more
if(read_more_content.length) {
    if (read_more_content[0].scrollHeight > read_more_content.innerHeight() + .5 ) {
        read_more_button.show()
        read_more_button.on('click', () => {
            if (read_more_content.hasClass('unclipped')) {
                read_more_content.removeClass('unclipped')
                read_more_button.find('p').html("Read More")
            } else {
                read_more_content.addClass('unclipped')
                read_more_button.find('p').html("Read Less")
            }
        })
    } else {
        read_more_button.hide()
    }
}

//book now button
$(window).on('scroll load', () => {
    if(window.scrollY >= 300) {
        book_now_btn.addClass('show-btn')
    }else {
        book_now_btn.removeClass('show-btn')
    }
})

//pop-up map/reviews
$('.close-container').on('click', () => {
    $popup.css('display', 'none')
})

$('.property-pop-up').on('click', (event) => {
    if($(event.currentTarget).hasClass('pop-up-map')) {
        $('.property-reviews').css('display', 'none')
        $('.acf-map').css('display', 'block')
    } else {
        $('.property-reviews').css('display', 'block')
        $('.acf-map').css('display', 'none')
    }
    $popup.css('display', 'flex')
})

$(window).on('resize load', function () {
    if($(window).innerWidth() < 1585) {
        let $facebook_reviews = $('.embedsocial-hashtag').detach()
        $('.additional-information-container').append($facebook_reviews)
    } else {
        let $facebook_reviews = $('.embedsocial-hashtag').detach()
        $('.property-offers-container').append($facebook_reviews)
    }
})


